import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg,
} from "../../../../services/cloudchipr.api";
import { updateDashboardFixedCacheKey } from "@/components/pages/dashboard/utils/constants/fixedCacheKeys";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { dashboardByIdDataSelector } from "@/store/dashboards/selectors/dashboard/dashboardByIdDataSelector";
import { RootState } from "@/store/store";

type UpdateDashboardByIdThunkArguments = {
  dashboardId: string;
  body: Partial<
    PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg["body"]
  >;
};

export const updateDashboardByIdThunk = createAsyncThunk(
  "dashboards/updateDashboardById",
  async (
    { dashboardId, body }: UpdateDashboardByIdThunkArguments,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const { putUsersMeOrganisationsCurrentDashboardsByDashboardId } =
      cloudChiprApi.endpoints;
    const dashboard = dashboardByIdDataSelector(state, dashboardId);

    if (!dashboard) {
      return;
    }

    try {
      return await dispatch(
        putUsersMeOrganisationsCurrentDashboardsByDashboardId.initiate(
          {
            dashboardId,
            body: {
              name: dashboard.name,

              is_protected: dashboard.protection_details?.is_protected ?? false,

              protection_description:
                dashboard.protection_details?.description ?? "",

              layout: dashboard.layout ?? {},

              dates: dashboard.dates ?? { label: "past_fourteen_days" },

              category_details: dashboard.category_details ?? {
                category_id: null,
                dimension_id: null,
              },

              ...body,
            },
          },
          { fixedCacheKey: updateDashboardFixedCacheKey },
        ),
      ).unwrap();
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
